import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { SqlSink } from './sql.copysink';
import { SqlServerTableDataset } from 'shell-models-lib';

@Metamodel.model({
    name: 'SqlServerSink',
    display: [],
    referable: true,
    tags: { datasetModel: [Metamodel.modelFor(SqlServerTableDataset)] }
})
export class SqlServerSink extends SqlSink {
    public static readonly MODEL: IModel;
    public static readonly WRITER_STORED_PROCEDURE_NAME: IAttribute;
    public static readonly WRITER_TABLE_TYPE: IAttribute;
}
